import { useState } from "react";
import course_Store from "../../store/course_store";
import { Form, SplitButton, ButtonGroup, Dropdown } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import styles from "../../css/styles.module.css";

export function AdditionalCourse(props) {
  const {
    index,
    course,
    handleStatusChange,
    coursestatus,
    statusRequest,
    coursesetBaseOnMajor,
    isBuildCreditCount,
  } = props;
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [selectedcoursestatus, setSelectedcoursestatus] = useState();
  // course Store data
  const categoryCourse_store_obj = course_Store((state) => state.courses);

  const handleSelectCourse = (selected, index) => {
    setSelectedCourse(selected);
    if (selected[0]) {
      const { code, name } = selected[0];
      const obj = categoryCourse_store_obj.data.find(
        (catCourse) => catCourse.name === name && catCourse.code === code
      );
      coursesetBaseOnMajor.data[index] = obj;
    }
  };

  const handleSelectStatus = (statusIndex) => {
    const status = coursestatus?.data[statusIndex] ?? "";
    setSelectedcoursestatus(status);
    handleStatusChange(statusIndex);
  };

  const isCurrentCourseSetSelected = () =>
    Object.entries(coursesetBaseOnMajor?.data?.[index]).length > 0;
  //   console.log( Object.entries (coursesetBaseOnMajor?.data?.[index]).length ==0 )
  return (
    <>
      <tr>
        <td>
          <Form.Group>
            <Typeahead
              disabled={
                selectedcoursestatus?.length === 0 ||
                statusRequest === "approved"
              }
              id="category2-selection"
              labelKey="code"
              onChange={(e, i) => handleSelectCourse(e, index)}
              options={categoryCourse_store_obj?.data ?? []}
              placeholder={`Choose a course...`}
              selected={selectedCourse}
            />
          </Form.Group>
          {/* <input type="text" value={name} onChange={handleNameChange} /> */}
        </td>
        <td>{coursesetBaseOnMajor?.data?.[index]?.credit ?? ""}</td>
        <td>{coursesetBaseOnMajor?.data?.[index]?.preRequisite ?? ""}</td>
        <td>
          <SplitButton
            as={ButtonGroup}
            className={`${styles.w_200}`}
            id={`dropdown2-variants-status-course`}
            variant="primary"
            disabled={
              !isCurrentCourseSetSelected() ||
              selectedcoursestatus?.length === 0 ||
              statusRequest === "approved"
            }
            onSelect={(e) => handleSelectStatus(e - 1)}
            title={selectedcoursestatus?.name ?? ""}
          >
            {(coursestatus?.data ?? []).map((element, index2) => {
              const courseset = coursesetBaseOnMajor?.data?.[index];
              const offer = courseset.offer;
              if (index2 !== 0 && index2 < 6) return;
              return (
                <Dropdown.Item
                  disabled={
                    offer === false && (element.isActive ?? false) === false
                  }
                  className="btn-outline-primary"
                  key={`additional-course-status-${element.id}`}
                  eventKey={element?.id ?? "-1"}
                >
                  {element?.name ?? ""}
                </Dropdown.Item>
              );
            })}
          </SplitButton>
        </td>
      </tr>
      {isBuildCreditCount && (
        <tr>
          <td></td>
          <td></td>
          {/* <td className='text-black fw-bold'>Total credits: {credits}</td> */}
          <td></td>
          <td></td>
        </tr>
      )}
    </>
  );
}
